import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-coming-soon',
  standalone: true,
  imports: [],
  templateUrl: './coming-soon.html',
  styleUrls: ['./coming-soon.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComingSoon {}
